const viewTitleStyle = {
  margin: '0 0 10px 10px'
}

export {
  viewTitleStyle
};